const copyWithExecCommand = (text) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);
  const ok = document.execCommand('copy');
  textarea.remove();
  if (!ok) {
    throw new Error('Copy command failed');
  }
};

export const copyTextToClipboard = async (text) => {
  const value = String(text ?? '');
  if (window.workloopRealm?.writeClipboard) {
    await window.workloopRealm.writeClipboard(value);
    return;
  }
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return;
    } catch {
      // Desktop / non-secure contexts often reject Clipboard API.
    }
  }
  copyWithExecCommand(value);
};
